module.exports = __webpack_public_path__ + "img/lux_xcryptochips.fc89b20.png";